module.exports = __webpack_public_path__ + "dist/img/iteration.a85f22ae.jpg";